import { formatUsd } from "@breakout/ui/utils"

/**
 * Get the appropriate text color class for a P&L value.
 * Green for positive, red for negative, default for zero.
 */
export function getPnlColor(pnl: number): string {
	if (pnl > 0) {
		return "text-emerald-600"
	}
	if (pnl < 0) {
		return "text-rose-600"
	}
	return "text-text-primary"
}

/**
 * Format a P&L value with sign prefix.
 * Positive values get a "+" prefix.
 */
export function formatPnl(pnl: number): string {
	if (pnl === 0) {
		return "$0.00"
	}
	const sign = pnl > 0 ? "+" : ""
	return `${sign}${formatUsd(pnl)}`
}

/** Default stats object for position data */
export const DEFAULT_POSITION_STATS = {
	totalValue: 0,
	totalCostBasis: 0,
	totalPnl: 0,
	totalClaimable: 0,
	activeCount: 0,
	closedCount: 0,
} as const
